import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { ChartLoading } from '../ChartComponent'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartDivergingBar } from './useGetChartDivergingBar'
import { ChartDivergingBarContent } from './ChartDivergingBarContent'

export const ChartDivergingBarComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartDivergingBar(id, tileFilterSelections)

  return (
    <ChartDivergingBarContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartDivergingBarComponentLoading() {
  return <ChartLoading />
}
